import React from 'react';
import { useTranslation } from 'react-i18next';
import { CreditCard, ShieldCheck, Wallet } from 'lucide-react';

const CREDIT_ITEMS = [
  { key: 'package', Icon: Wallet },
  { key: 'advance', Icon: CreditCard },
  { key: 'guard', Icon: ShieldCheck },
] as const;

export const CreditsSection: React.FC = () => {
  const { t } = useTranslation();

  return (
    <section className="border-y border-slate-200 bg-white text-slate-950">
      <div className="mx-auto grid max-w-7xl gap-8 px-5 py-16 md:grid-cols-[0.9fr_1.1fr] md:px-8">
        <div>
          <p className="text-sm font-semibold uppercase text-teal-700">
            {t('landing.credits.eyebrow')}
          </p>
          <h2 className="mt-3 text-3xl font-bold leading-tight md:text-4xl">
            {t('landing.credits.title')}
          </h2>
          <p className="mt-4 text-base leading-7 text-slate-600">
            {t('landing.credits.description')}
          </p>
        </div>

        <div className="grid gap-4 sm:grid-cols-3">
          {CREDIT_ITEMS.map(({ key, Icon }) => (
            <article key={key} className="rounded-lg border border-slate-200 bg-slate-50 p-5">
              <div className="mb-4 flex h-10 w-10 items-center justify-center rounded-lg bg-teal-100 text-teal-700">
                <Icon size={20} />
              </div>
              <h3 className="text-base font-semibold">{t(`landing.credits.items.${key}.title`)}</h3>
              <p className="mt-3 text-sm leading-6 text-slate-600">
                {t(`landing.credits.items.${key}.description`)}
              </p>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
};
